import React from 'react';
import { Link } from 'react-router-dom';
import {
    Container,
    Header,
    Segment
} from 'semantic-ui-react';
import { useAuth } from '../providers';

import CurrentlyLive from '../components/CurrentlyLive';

export default function HomePage() {
    const { authenticated } = useAuth()

    return (
        <Segment inverted>
            <Container text className='description'>
                <Header as='h2' inverted>The Twitching of Isaac</Header>
                <p>
                    The Twitching of Isaac is a fan made mod for The Binding of Isaac that enables Twitch chat to interact with a participating stream.
                </p>
                <p>
                    Allow your Twitch chat to interact with your Binding of Isaac games, whether it is giving and taking items, or spawning in Hush randomly. As the streamer you can enable or disable
                    the commands you want your community to be able to use, as well as specify if a commad is available to just your subscribers. Additonally, you can configure Donation incentives,
                    or Channel Point redemption of commands.
                </p>
                {authenticated ?
                    <p>
                        To get started, <Link to='/login'>Login</Link> now, and follow the Getting Started instructions!
                    </p>
                    : ''}
                <Header as='h3' inverted>Features</Header>
                <ul>
                    <li>Over <em>30</em> (and growing) available <Link to="/help">commands</Link>, and the ability to create custom commands using an easy to use editor without any programming experience.</li>
                    <li>Fine grained control for each command for command availability, subscriber only mode, rate limits, as well as renaming or translating command names.</li>
                    <li>Manage a ban list of items or enemies you don't want your chat to be able to use.</li>
                    <li>Accept PayPal donations with incentives tied to live interaction with the mod.</li>
                    <li>Channel Point Redemptions tied to the mod, configurable by the streamer.</li>
                    <li>Overlay widgets to add to your stream to show the tracked inventory, or the actions that your chat has taken.</li>
                    <li>Featured visibilty and promotion on the <Link to="/live">Currently Live</Link> page, without any extra steps.</li>
                </ul>
                <p>
                    The mod is under constant development, and new features and enhancements are always in progress. It is made available to you 100% for free, but if you want to support the
                    continued development, check out the <a href="https://www.patreon.com/twitchingofisaac">Patreon</a>, or you can always subscribe to me on <a href="https://twitch.tv/sublimnl">Twitch</a>.
                </p>
            </Container>
            <CurrentlyLive />
        </Segment>
    )
};
